import "./FeaturedPosts.css";
import Image from "../Image/Image";
import { Link } from "react-router-dom";
import api from "../../../../api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const fetchPost = async () => {
  const res = await api.get("Blog/featuredPosts", {
    params: { limit: 4 },
  });
  return res.data.data;
};

const FeaturedPosts = () => {
  const {
    isPending,
    error,
    data: posts,
  } = useQuery({
    queryKey: ["featuredPosts"],
    queryFn: fetchPost,
  });

  if (isPending) return <>Loading...</>;
  if (error) return <>Something went wrong</>;
  if (!posts || posts.length === 0) return <>ფავორიტი პოსტები ვერ მოიძებნა</>;

  const limitedPosts = posts.slice(0, 4);
  const topPost = limitedPosts[0];
  const otherPosts = limitedPosts.slice(1);

  return (
    <div className="featured-posts-container md:mt-8 flex flex-col lg:flex-row gap-6 bg-white rounded-3xl xl:rounded-3xl px-4 py-5 shadow-lg">
      {/* Top post */}
      <div className="w-full lg:w-1/2 flex flex-col gap-2">
        <Image
          src={topPost.coverImgUrl}
          width=""
          height=""
          alt={topPost.title}
          className="rounded-2xl object-cover w-full aspect-video"
        />
        <Link
          to={`/blog/posts/${topPost.id}`}
          className="text-xl lg:text-3xl font-semibold lg:font-bold"
        >
          {topPost.title}
        </Link>
        <div className="flex flex-wrap items-center gap-4">
          <Link
            className="text-blue-800 text-sm lg:text-lg"
            to={`posts?category=${topPost.categoryName}`}
          >
            {topPost.categoryName}
          </Link>
          <span className="text-gray-500 text-sm">
            {topPost.createdAt.slice(0, 10)}
          </span>
        </div>
      </div>

      {/* Other featured posts */}
      <div className="w-full lg:w-1/2 flex flex-col gap-4">
        {otherPosts.map((post: any) => (
          <div
            key={post.id}
            className="featured-post-item lg:h-1/3 flex justify-between gap-4"
          >
            <Image
              src={post.coverImgUrl}
              width=""
              height=""
              alt={post.title}
              className="rounded-xl object-cover w-1/3 aspect-video"
            />
            <div className="w-2/3">
              <div className="flex flex-col flex-wrap items-start gap-4 text-sm mb-4">
                <Link to={`/blog/posts/${post.id}`} className="font-semibold">
                  {post.title}
                </Link>
                <Link
                  to={`posts?category=${post.categoryName}`}
                  className="text-blue-800"
                >
                  {post.categoryName}
                </Link>
                <span className="text-gray-500 text-sm">
                  {" "}
                  {post.createdAt.slice(0, 10)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeaturedPosts;
